module.exports = __webpack_public_path__ + "static/media/arrow-right-xsm-light.5b45ac91.svg";